import { render } from "./Interconsulta.vue?vue&type=template&id=515e5699&scoped=true"
import script from "./Interconsulta.vue?vue&type=script&lang=js"
export * from "./Interconsulta.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=515e5699&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=515e5699&scoped=true&lang=css"
import "./Interconsulta.vue?vue&type=style&index=2&id=515e5699&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515e5699"]])

export default __exports__